import { render, staticRenderFns } from "./ServiceScheduleTemplate.vue?vue&type=template&id=497fd667&"
import script from "./ServiceScheduleTemplate.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports